<template>
  <div id="indexPage">
    <index-header></index-header>
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>
<script>
import IndexHeader from '../../components/IndexHeader'

export default {
  data() {
    return {
      projectSearchInfo: '',
      projectStatus: '1',
    }
  },
  components: {
    IndexHeader,
  },
  methods: {},
}
</script>
<style lang="less" scoped>
#indexPage {
  width: 100%;
  height: 100%;
  background-color: #f2f3f4;
  .router-view {
    height: 300px;
  }
}
</style>